import React from 'react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

//Componentes auxiliares:
import CustomDatePicker from '../../../components/auditView/CustomDatePicker';
import CustomLateralModal from '../../../tools/components/CustomLateralModal';

//Estilos auxiliares:
import '../../../assets/css/date-picker-styles.css';

//Scripts auxiliares:
import { getCronNextDates } from '../../../tools/scripts/cronUtils';
import { colombiaWallClockToDate, nowInColombia, extractColombiaFields } from '../../../tools/scripts/colombiaTime';
import CustomCheckbox from '../../../tools/components/CustomCheckbox';
import { registerAuditProcess } from '../../../tools/scripts/customFetching';
import { getSourceTitleText, getSourceSubtitleText } from '../../../views/common/downloadSourcesRenderingFunctions';

// Helper: convert a Date picked by the user (which uses browser-local
// timezone fields) into a Date whose underlying timestamp corresponds to the
// same wall-clock time interpreted as Colombia time. This way a user in
// Canada picking "3:00 AM" gets a Date equivalent to "3:00 AM Bogota".
const pickedDateToColombiaWallClock = (d) => {
    if (!d) return d;
    return colombiaWallClockToDate(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes()
    );
};

// Inverse of pickedDateToColombiaWallClock: take a real timestamp coming from
// the backend (which represents a real Colombia instant in UTC form) and
// produce a Date whose .getHours()/.getDate() in browser-local match the
// Colombia wall-clock fields. Used so the picker shows consistent hours no
// matter where the browser is physically located.
const colombiaInstantToPickerDate = (utcIso) => {
    if (!utcIso) return null;
    const fields = extractColombiaFields(new Date(utcIso));
    return new Date(
        fields.year,
        fields.month,
        fields.day,
        fields.hour,
        fields.minute,
        0,
        0
    );
};

const dateFormatter = require('../../../tools/formatters/dateFormatter');

//Estilos base:
const mutedText = { fontSize: 12, textTransform: "none" };

// Defaults use Colombia wall-clock time (not the browser's timezone).
const _colNow = nowInColombia();
//Constantes auxiliares:
const defaultCronConfig = {
    minute: _colNow.minute(),
    hour: _colNow.hour(),
    day_of_week: "*",
    day_of_month: "*",
    month_of_year: "*",

    expires: null,
    description: "Cada día a las " + _colNow.format("HH:mm"),
}

class RecurrencyConfig extends React.Component {

    constructor() {
        super();

        // Initial start_time uses Colombia now — but as a browser-local Date
        // whose wall-clock fields match Colombia. That way the picker shows
        // Colombia time regardless of browser timezone.
        const _col = nowInColombia();
        const _initialStart = new Date(
            _col.year(), _col.month(), _col.date(),
            _col.hour(), _col.minute(), 0, 0
        );

        this.state = {
            modalIsOpen: false,
            contentLoaded: false,

            start_time: _initialStart,
            minute: "*",
            hour: "*",
            day_of_week: "*",
            day_of_month: "*",
            month_of_year: "*",
            description: "",

            nextExecutionDates: [],

            finalDatePickerIsActive: false,
            userHasMadeChanges: false,
            firstTimeConfig: false,
        }
    }

    render() {
        return (
            <CustomLateralModal
                title={this.getModalTitleBasedOnStatus()}
                isOpen={this.props.isOpen} modalToggle={this.props.modalToggle}
                footerButtons={[this.getDeleteConfigButtonFromBackend(), this.getCreateConfigButtonFromBackend()]}>

                {this.getCronConfigurationContent()}
                {this.getLoadingMessage()}

                {this.getUpdateConfigButtonFromBackend()}

            </CustomLateralModal>
        );
    }

    componentDidMount() {
        this.fetchCronConfigFromBackend(this.props.downloadSource.id);
    }

    //Métodos para renderizado:
    getCreateConfigButtonFromBackend = () => {
        if (this.state.firstTimeConfig) {
            return (
                <Button color="success" key={"createCronConfigButton." + this.props.downloadSource.id}
                    onClick={() => { this.setCronConfigFromBackend(this.props.downloadSource.id); }}>
                    Programar
                </Button>
            );
        }
    }

    getCronConfigurationContent = () => {
        if (this.state.contentLoaded) {
            let selectOptions = this.getOptionsBasedOnDate();

            return (
                <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                    {/* {this.getHelpTextBlock()} */}

                    {this.getUnsettedConfigText()}
                    {this.getCronDescriptionText()}

                    <div style={{ marginBottom: 30 }}>
                        <p>Fecha de la <b>primera descarga</b> <span style={mutedText}>(hora Colombia)</span>:</p>
                        <CustomDatePicker style={{ padding: 0 }} inputStyle={{ height: 38 }}
                            currentDate={this.state.start_time} onChange={(e) => {
                                // The picker uses browser-local time. We interpret the
                                // picked hour/minute/day fields as "Colombia wall-clock"
                                // — not the browser's timezone. The Date is kept as-is
                                // in state so the picker shows consistent values; only
                                // at network boundary (setCronConfigFromBackend) is it
                                // converted to a real Colombia timestamp.
                                const newState = {
                                    start_time: e,
                                    minute: e.getMinutes(),
                                    hour: e.getHours(),
                                    userHasMadeChanges: true,
                                };
                                this.setState(newState, () => {
                                    const refreshedOptions = this.getOptionsBasedOnDate();
                                    const activeOption = refreshedOptions.find(opt => {
                                        const cron = opt.getCronObject();
                                        return cron.day_of_week === this.state.day_of_week
                                            && cron.day_of_month === this.state.day_of_month
                                            && cron.month_of_year === this.state.month_of_year;
                                    }) || refreshedOptions[0];
                                    const cronObj = activeOption.getCronObject();
                                    this.setState({
                                        ...cronObj,
                                        nextExecutionDates: this.getNextExecutionDates(
                                            cronObj, 5,
                                            this.state.finalDatePickerIsActive ? this.state.expires : null,
                                            this.state.start_time
                                        ),
                                    });
                                });
                            }} />

                        <br />
                        <p>Debo <b>repetir</b>:</p>
                        <Select className="input" options={selectOptions}
                            placeholder={(!this.state.firstTimeConfig) ? "Frecuencia preestablecida" : ""}
                            defaultValue={(this.state.firstTimeConfig) ? selectOptions[0] : null}
                            onChange={(e) => {
                                this.setState({
                                    ...e.getCronObject(),
                                    userHasMadeChanges: true,
                                    nextExecutionDates: this.getNextExecutionDates(
                                        e.getCronObject(),
                                        5,
                                        this.state.finalDatePickerIsActive ? this.state.expires : null,
                                        this.state.start_time
                                    ),
                                });
                            }}
                            styles={{
                                // ...styles,
                                control: (base, state) => ({
                                    ...base,
                                    boxShadow: 'none',
                                    '&:hover': {
                                        borderColor: 'rgb(121,174,228)',
                                        boxShadow: '0 0 5px rgba(81, 203, 238, 1)',
                                    },
                                }),
                            }} />

                        <br />
                        <CustomCheckbox checked={this.state.finalDatePickerIsActive}
                            onChange={(e) => {
                                this.setState({
                                    userHasMadeChanges: true,
                                    finalDatePickerIsActive: !this.state.finalDatePickerIsActive,
                                    nextExecutionDates: this.getNextExecutionDates(
                                        this.state,
                                        5,
                                        (!this.state.finalDatePickerIsActive) ? this.state.expires : null,
                                        this.state.start_time
                                    )
                                });
                            }}
                            itemRendering={<span>Fecha de <b>finalización</b></span>} />
                        {this.getFinalDatePicker()}
                    </div>

                    {this.getExecutionDatesRendered()}
                </div>
            );
        }
    }

    getCronDescriptionText = () => {
        if (this.state.description !== "") {
            if (this.state.firstTimeConfig) {
                return (
                    <p className="category" style={{ ...mutedText }}>
                        {"Las descargas se ejecutarían " + this.state.description.toLowerCase() + " (hora Colombia)"}
                    </p>
                );
            }
            else {
                return (
                    <p className="category" style={{ ...mutedText }}>
                        {"Las descargas se están ejecutando " + this.state.description.toLowerCase() + " (hora Colombia)"}
                    </p>
                );
            }
        }
    }

    getDeleteConfigButtonFromBackend = () => {
        if (!this.state.firstTimeConfig) {
            return (
                <Button color="danger" key={"deleteCronConfigButton." + this.props.downloadSource.id}
                    onClick={() => { this.destroyCronConfigFromBackend(this.props.downloadSource.id) }}>
                    Eliminar
                </Button>
            );
        }
    }

    getExecutionDatesRendered = () => {
        if (this.state.nextExecutionDates.length > 0) {
            const moment = require("moment-timezone");
            const COL_TZ = "America/Bogota";
            return (
                <div>
                    <hr />
                    <p style={{}}><b>Próximas</b> descargas <span style={mutedText}>(hora Colombia)</span>:</p>

                    {this.state.nextExecutionDates.map((date, i) => {
                        // Render in Colombia time so users in any browser
                        // timezone see consistent hours.
                        const colMoment = moment.tz(date, COL_TZ);
                        return (
                            <p key={"cronExecutionDate." + i + "." + (new Date()).getTime()}>
                                <b style={{ marginLeft: 10, marginRight: 10 }}>{(i + 1) + ": "}</b>
                                {colMoment.format("MMM D, YYYY") + " a las " + colMoment.format("HH:mm")}
                            </p>
                        );
                    })}
                </div>
            );
        }
    }

    getFinalDatePicker = () => {
        if (this.state.finalDatePickerIsActive) {
            let finalDate = this.state.expires;
            if (!finalDate) {
                // Default: 1 year from Colombia now (as picker fake-local Date).
                const _col = nowInColombia().add(1, "year");
                finalDate = new Date(
                    _col.year(), _col.month(), _col.date(),
                    _col.hour(), _col.minute(), 0, 0
                );
            }

            return (
                <CustomDatePicker style={{ padding: 0 }} inputStyle={{ height: 38 }}
                    currentDate={finalDate} onChange={(e) => {
                        this.setState({
                            expires: e,
                            nextExecutionDates: this.getNextExecutionDates(
                                this.state, 5, e, this.state.start_time
                            ),
                            userHasMadeChanges: true,
                        });
                    }} />
            );
        }
    }

    getHelpTextBlock = () => {
        if (!JSON.parse(localStorage.getItem("userHasCheckedRecurreyncyModalHelpText"))) {
            return (
                <React.Fragment>
                    <div style={{ textAlign: "right" }}>
                        <p style={{ marginBottom: 5 }}>Programación <b>recurrente</b></p>
                        <p className="category" style={{ ...mutedText }}>
                            Utiliza esta herramienta para programar ejecuciones automáticas que se repiten cada cierto tiempo
                        </p>
                        <p className="category"
                            style={{ ...mutedText, textDecoration: "underline", textTransform: "lowercase", fontSize: 10, cursor: "pointer" }}>
                            No mostrar de nuevo
                        </p>
                    </div>

                    <hr />
                </React.Fragment>
            );
        }
    }

    getLoadingMessage = () => {
        if (!this.state.contentLoaded) {
            return (
                <div style={{ paddingTop: 20, paddingBottom: 20, textAlign: "center" }}>
                    <p>Cargando...</p>
                </div>
            );
        }
    }

    getModalTitleBasedOnStatus = () => {
        return (
            <p style={{ marginBottom: 5, textTransform: "capitalize" }}>
                <b>
                    {getSourceTitleText(this.props.downloadSource.description)}
                </b>
                <span style={{ textTransform: "none" }}>
                    {getSourceSubtitleText(this.props.downloadSource.description)}
                </span>
            </p>
        );
    }

    getUnsettedConfigText = () => {
        if (this.state.description === "") {
            return (
                <p className="category" style={{ ...mutedText }}>
                    <b>Aún no has seteado recurrencia para esta fuente de descarga</b>.
                    Manipula las variables y setea la configuración que desees
                </p>
            );
        }
    }

    getUpdateConfigButtonFromBackend = () => {
        if (!this.state.firstTimeConfig && this.state.userHasMadeChanges) {
            return (
                <React.Fragment>
                    <hr />
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button color="info" key={"updateCronConfigButton." + this.props.downloadSource.id}
                            onClick={() => {
                                this.updateCronConfigFromBackend(this.props.downloadSource.id);
                            }}>
                            Confirmar cambios
                        </Button>
                    </div>
                </React.Fragment>
            );
        }
    }

    //Métodos operativos:
    destroyCronConfigFromBackend = (sourceId) => {
        fetch(process.env.REACT_APP_API_URL + "/sources/" + sourceId + "/periodic_task_destroy/", {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.props.activeUser.authToken
            },
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                    case 204:
                        this.fireSuccessAlert("La programación anterior fue <b>eliminada con éxito</b>");
                        this.setState({
                            ...defaultCronConfig,
                            firstTimeConfig: true,
                            userHasMadeChanges: false,
                            nextExecutionDates: this.getNextExecutionDates(defaultCronConfig)
                        });

                        registerAuditProcess(this.props, {
                            "event_type": "DOWNLOAD_PROGRAMMING",
                            "description": "El usuario <b>canceló la programación</b> de "
                                + this.props.downloadSource.description.replace(":", ": ")
                        });

                        this.props.reloadSourcesMethod();
                        break;

                    default:
                        this.fireErrorAlert("La programación <b>no pudo ser eliminada</b>");
                        break;
                }
            })
            .catch(error => { console.log(error); this.fireErrorAlert(); });
    }

    fetchCronConfigFromBackend = (sourceId) => {
        fetch(process.env.REACT_APP_API_URL + "/sources/" + sourceId + "/periodic_task_retrieve/", {
            method: 'GET',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json()
                            .then(cronConfig => {
                                if (cronConfig.periodic_task !== "") {
                                    // Convert backend timestamps (real Colombia instants)
                                    // to "fake local" Dates so the picker displays the same
                                    // Colombia wall-clock time regardless of browser TZ.
                                    const startPicker = colombiaInstantToPickerDate(cronConfig.periodic_task.start_time);
                                    const expiresPicker = colombiaInstantToPickerDate(cronConfig.periodic_task.expires);
                                    this.setState({
                                        firstTimeConfig: false,
                                        ...cronConfig.periodic_task,
                                        ...cronConfig.crontab_schedule,
                                        periodic_task_id: cronConfig.periodic_task.id,
                                        crontab_schedule_id: cronConfig.crontab_schedule.id,
                                        start_time: startPicker || new Date(),

                                        finalDatePickerIsActive: !!cronConfig.periodic_task.expires,
                                        expires: expiresPicker,

                                        nextExecutionDates: this.getNextExecutionDates(
                                            cronConfig.crontab_schedule,
                                            5,
                                            expiresPicker,
                                            startPicker
                                        )
                                    });
                                }
                                else {
                                    this.setState({
                                        ...defaultCronConfig,
                                        firstTimeConfig: true,
                                        nextExecutionDates: this.getNextExecutionDates(defaultCronConfig)
                                    });
                                }
                            })
                            .catch(error => { console.log(error); });
                        break;

                    default:
                        console.log("Error descargando la configuración cron del source " + sourceId + " desde backend...");
                        break;
                }

                this.setState({ contentLoaded: true });
            })
            .catch(error => { console.log(error); });
    }

    getNextExecutionDates = (cronObject, limit = 5, finalDate, pickedStartTime) => {
        // Convert the picker's "fake-local" Date (whose wall-clock fields
        // reflect Colombia time regardless of browser TZ) into a real
        // Colombia instant so cron-parser's currentDate matches what the
        // backend's PeriodicTask.start_time actually is. Without this, the
        // preview ignored start_time entirely and always listed firings
        // starting from "now" — confusing users who scheduled days in the
        // future.
        //
        // Only use the picked start time as the cron anchor when it's in
        // the future. For bots that have already started their recurring
        // schedule, anchoring to a past start_time would cause the preview
        // to list historical firings; anchoring to "now" gives the user
        // what they actually want to see (upcoming runs).
        let startTime = null;
        if (pickedStartTime) {
            const realInstant = pickedDateToColombiaWallClock(pickedStartTime);
            if (realInstant && realInstant > new Date()) {
                startTime = realInstant;
            }
        }
        return getCronNextDates(cronObject, limit, finalDate, startTime)
    }

    getOptionsBasedOnDate = () => {
        let date = this.state.start_time;
        let relatedDayOfTheWeek = { value: date.getDay(), label: dateFormatter.getDayOfTheWeekName(date) };

        return [
            {
                value: "EVERY_DAY",
                label: "Cada día",
                getCronObject: () => {
                    return ({
                        "minute": date.getMinutes(),
                        "hour": date.getHours(),
                        "day_of_week": "*",
                        "day_of_month": "*",
                        "month_of_year": "*",
                        "description": "Cada día a las " + dateFormatter.getShortHour(date)
                    });
                }
            },
            {
                value: "ONCE_A_EVERY_WEEK",
                label: "Cada " + relatedDayOfTheWeek.label,
                getCronObject: () => {
                    return ({
                        "minute": date.getMinutes(),
                        "hour": date.getHours(),
                        "day_of_week": relatedDayOfTheWeek.value,
                        "day_of_month": "*",
                        "month_of_year": "*",
                        "description": "Cada " + relatedDayOfTheWeek.label +
                            " a las " + dateFormatter.getShortHour(date)
                    });
                }
            },
            {
                value: "ONCE_A_MONTH",
                label: "Cada mes el " + date.getDate(),
                getCronObject: () => {
                    return ({
                        "minute": date.getMinutes(),
                        "hour": date.getHours(),
                        "day_of_week": "*",
                        "day_of_month": date.getDate(),
                        "month_of_year": "*",
                        "description": "El " + date.getDate() + " de todos los meses" +
                            " a las " + dateFormatter.getShortHour(date)
                    });
                }
            },
            {
                value: "ONCE_A_YEAR",
                label: "Cada año el " + date.getDate() + " de " + dateFormatter.getMonthName(date, false),
                getCronObject: () => {
                    return ({
                        "minute": date.getMinutes(),
                        "hour": date.getHours(),
                        "day_of_week": "*",
                        "day_of_month": date.getDate(),
                        "month_of_year": date.getMonth() + 1,
                        "description": "Una vez al año, el " + date.getDate() + " de "
                            + dateFormatter.getMonthName(date, false) + " a las " + dateFormatter.getShortHour(date),
                    });
                }
            },
            {
                value: "FIRST_DAY_OF_MONTH",
                label: "El primer día de cada mes",
                getCronObject: () => {
                    return ({
                        "minute": date.getMinutes(),
                        "hour": date.getHours(),
                        "day_of_week": "*",
                        "day_of_month": "1",
                        "month_of_year": "*",
                        "description": "El primer día de cada mes"
                            + " a las " + dateFormatter.getShortHour(date),
                    });
                }
            },
            {
                value: "ALL_WORKABLE_DAYS",
                label: "Todos los días laborales",
                getCronObject: () => {
                    return ({
                        "minute": date.getMinutes(),
                        "hour": date.getHours(),
                        "day_of_week": "1-5",
                        "day_of_month": "*",
                        "month_of_year": "*",
                        "description": "Todos los días laborales"
                            + " a las " + dateFormatter.getShortHour(date),
                    });
                }
            },
        ];
    }

    setCronConfigFromBackend = (sourceId) => {
        // Convert browser-local picker values to real Colombia-time timestamps
        // before sending. This keeps schedules consistent regardless of where
        // the user's browser is physically located.
        const startTimeCol = pickedDateToColombiaWallClock(this.state.start_time);
        const expiresCol = this.state.finalDatePickerIsActive
            ? pickedDateToColombiaWallClock(this.state.expires)
            : null;

        fetch(process.env.REACT_APP_API_URL + "/sources/" + sourceId + "/periodic_task_create/", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.props.activeUser.authToken
            },
            body: JSON.stringify({
                "periodic_task": {
                    "name": sourceId,
                    "priority": null,
                    "expires": expiresCol,
                    "one_off": false,
                    "start_time": startTimeCol,
                    "enabled": true,
                    "description": this.state.description
                },
                "crontab_schedule": {
                    "minute": this.state.minute,
                    "hour": this.state.hour,
                    "day_of_week": this.state.day_of_week,
                    "day_of_month": this.state.day_of_month,
                    "month_of_year": this.state.month_of_year,
                }
            })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        this.fireSuccessAlert("La programación fue <b>configurada con éxito</b>");
                        this.setState({ firstTimeConfig: false, userHasMadeChanges: false });
                        this.fetchCronConfigFromBackend(sourceId);

                        registerAuditProcess(this.props, {
                            "event_type": "DOWNLOAD_PROGRAMMING",
                            "description": "El usuario <b>definió la programación</b> de "
                                + this.props.downloadSource.description.replace(":", ": ")
                                + ". La descarga se ejecutará " + this.state.description.toLowerCase()
                        });

                        this.props.reloadSourcesMethod();
                        break;

                    default:
                        this.fireErrorAlert("La programación <b>no pudo ser configurada</b>");
                        break;
                }
            })
            .catch(error => { console.log(error); this.fireErrorAlert(); });
    }

    updateCronConfigFromBackend = (sourceId) => {
        // Same Colombia-wallclock conversion as setCronConfigFromBackend.
        const startTimeCol = pickedDateToColombiaWallClock(this.state.start_time);
        const expiresCol = this.state.finalDatePickerIsActive
            ? pickedDateToColombiaWallClock(this.state.expires)
            : null;

        fetch(process.env.REACT_APP_API_URL + "/sources/" + sourceId + "/periodic_task_create/", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.props.activeUser.authToken
            },
            body: JSON.stringify({
                "periodic_task": {
                    "id": this.state.periodic_task_id,
                    "name": sourceId,
                    "priority": null,
                    "expires": expiresCol,
                    "one_off": false,
                    "start_time": startTimeCol,
                    "enabled": true,
                    "description": this.state.description,
                    "crontab": this.state.crontab
                },
                "crontab_schedule": {
                    "id": this.state.crontab_schedule_id,
                    "minute": this.state.minute,
                    "hour": this.state.hour,
                    "day_of_week": this.state.day_of_week,
                    "day_of_month": this.state.day_of_month,
                    "month_of_year": this.state.month_of_year,
                }
            })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        this.fireSuccessAlert("La programación fue <b>actualizada con éxito</b>");
                        this.setState({ firstTimeConfig: false, userHasMadeChanges: false });

                        registerAuditProcess(this.props, {
                            "event_type": "DOWNLOAD_PROGRAMMING",
                            "description": "El usuario <b>actualizó la programación</b> de "
                                + this.props.downloadSource.description.replace(":", ": ")
                                + ". Ahora es: " + this.state.description.toLowerCase()
                        });

                        this.props.reloadSourcesMethod();
                        break;

                    default:
                        this.fireErrorAlert("La programación <b>no pudo ser actualizada</b>");
                        break;
                }
            })
            .catch(error => { console.log(error); this.fireErrorAlert(); });
    }

    //Métodos Swal:
    fireErrorAlert = (message) => {
        Swal.fire('', 'El proceso falló', 'error');
    }

    fireSuccessAlert = (message) => {
        Swal.fire('', 'El proceso se <b>completó con éxito</b>', 'success');
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering,
    };
};

export default connect(mapStateToProps)(RecurrencyConfig);